<!--账单列表-->
<template>

    <div>
        <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft">
            <van-icon name="filter-o" text="筛选" slot="right" size="20px" @click="showPopup()"/>
        </van-nav-bar>
        <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item v-model="pageInfo.orderType.col" :options="orderCols" @change="orderChange" />
            <van-dropdown-item v-model="pageInfo.orderType.type" :options="orderTypes" @change="orderChange" />
        </van-dropdown-menu>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="哥哥找过了,没有更多了,爱宝爱宝"
                    loading-text="宝不着急,哥哥正在找,嗷呜~"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad"
            >
                <van-swipe-cell v-for="item in list" :key="item.finId">

                    <van-cell >

                        <!-- 使用 title 插槽来自定义标题 -->
                        <template slot="title">
                            <van-row type="flex" justify="space-between">
                                <van-col span="11" >
                                    <span style="font-size: 20px">{{splitDate(item.inputDate)}}</span>
                                    <span> {{splitTime(item.inputDate)}}</span>
                                </van-col>
                                <van-col span="6">
                                    <van-tag  plain  :type="getFinType(item.finType)" style="float: right;">{{item.finTypeName}}</van-tag>
                                    <van-tag  plain  type="warning" style="float: right;">{{item.billTypeName}}</van-tag>
                                </van-col>
                                <van-col span="7">
                                    <span style="font-size: 20px;float: right;">￥{{item.amount}}</span>
                                </van-col>
                            </van-row>
                            <van-row type="flex" >
                                <van-col span="4" >{{item.belongName}}</van-col>
                                <van-col span="6" offset="8"><span style="float:left">{{item.sortName}}</span></van-col>
                                <van-col span="6"><span style="color:#969799;font-size: 12px">{{item.sortDetailName}}</span></van-col>
                            </van-row>

                            <van-row type="flex" v-if="item.finType == 12101">
                                <van-col span="24" >
                                    <van-tag  plain round  type="warning" style="margin-top:5px">{{item.payerName}}付款</van-tag>
<!--                                    <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.usePM">零花钱结算</van-tag>-->
                                    <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.payModeName">{{item.payModeName}}</van-tag>
                                    <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.rollOverAccounts">轧账余额{{item.rollOverAccounts}}</van-tag>
                                </van-col>
                            </van-row>
                            <van-row type="flex" v-if="item.finType == 12101" >
                                <van-col span="24" >
                                    <span v-for="tag in item.tags" :key="tag.tagId">
                                        <van-tag  plain   type="primary" v-if="isShow(item.tags,tag.attrId,true)" style="margin-top:5px;margin-right:5px " @click="selectTag(tag.finId,tag.tagId,$event)">{{tag.tagName}}</van-tag>
                                    </span>
                                    <span v-for="tag in tags" :key="tag.tagId">
                                        <van-tag  plain   type="default" v-if="isShow(item.tags,tag.attrId,false)" style="margin-top:5px;margin-right:5px" @click="selectTag(item.finId,tag.attrId,$event)">{{tag.attrName}}</van-tag>
                                    </span>

                                </van-col>
                            </van-row>
                            <van-row type="flex" justify="space-between">
                                <van-col span="24" >
                                    <span style="float: left;color:#969799;font-size: 12px">{{item.remark}}</span>
                                </van-col>

                            </van-row>
                        </template>

                    </van-cell>
                    <template slot="right">
                        <van-button square plain type="info" text="修改" class="upd-button" @click="alterFin(item.finId)"/>
                        <van-button square plain type="danger" text="删除" class="upd-button" @click="removeFin(item.finId)"/>
                    </template>
                    <template slot="left">
                        <van-button square plain type="info" text="在途" class="upd-button" @click="alterTransFin(item.finId)"/>
                    </template>
                </van-swipe-cell>
            </van-list>

        </van-pull-refresh>
        <van-popup v-model="popupShow" round  position="right" :style="{ width: '80%',height: '100%' }" >
            <multiple-query @qryData="getQryData($event)"></multiple-query>
        </van-popup>


    </div>

</template>

<script>
    import FinNav from '../other/FinNav'
    import MultipleQuery from "./MultipleQuery";
    import * as MyApi from '../../api/URLApiAddr.js'
    export default {
        name: 'FinList',
        components: {
            FinNav,
            MultipleQuery
        },
        data() {
            return {
                title: '账单详情',
                list: [],
                error: false,
                loading: false,
                finished: false,
                refreshing: false,
                tagType: "danger",
                pageInfo:{
                    day:'',
                    sortDetail:'',
                    finType:Number,
                    month:'',
                    current:1,
                    size:25,
                    total:-1,
                    belongs: [],
                    startDate: '',
                    endDate: '',
                    sorts: [],
                    payers: [],
                    finTypes: [],
                    details: [],
                    tagIds: [],
                    orderType:{
                        col: "input_date",
                        type: "desc"
                    },
                    statisticsFlag: '' //统计类型
                },
                popupShow: false,
                tags: Object,
                orderCols: [
                    { text: '记账日期', value: 'input_date' },
                    { text: '金额', value: 'amount' },
                ],
                orderTypes: [
                    { text: '升序', value: 'asc' },
                    { text: '降序', value: 'desc' },
                ]


            }
        },
        watch:{
            // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
            $route: 'getParams'
        },
        created() {
            debugger;
            //this.initTags()
            this.getParams()

        },
        mounted(){
            this.initTags()
        },
        methods: {
            onLoad() {

                // if(this.pageInfo.month == undefined || this.pageInfo.month == ''){
                //     this.$toast.fail("月份不能为空")
                //     this.finished = true
                //     return false
                // }

                debugger
                if (this.refreshing) {
                    this.list = [];
                    this.pageInfo.current = 1
                    this.pageInfo.total=-1
                    this.refreshing = false
                }

                let ths = this
                if(this.list.length == this.pageInfo.total){
                    this.finished = true;
                    return false
                }
                let params = this.pageInfo
                this.$axios.post(MyApi.QRY_FIN_LIST,params/*,options*/)
                    .then((response) =>  {
                        debugger
                        let code = response.code;
                        if(code == '200'){

                            let data = response.data
                            if(data.records.length >0){
                                ths.pageInfo.current ++

                                //ths.list = data.records
                                ths.list = ths.list.concat(data.records)
                                ths.pageInfo.total = data.total;
                                if(ths.list.length == data.records.total){
                                    this.finished = true;
                                }

                            }else{
                                this.finished = true;
                            }
                        }
                        this.loading = false;

                    })
                    .catch((err) =>{
                        this.loading = false
                        this.error = true
                        this.$toast.fail("数据初始化异常"+err);
                    })

            },
            splitDate(inputDate) {
                return inputDate.substr(0,10)
            },
            splitTime(inputDate) {
                return inputDate.substr(11,5)
            },
            getFinType(finType,finTypeName){
                if(finType == '12101'){
                    return "danger"
                }else{
                    return  "primary"
                }
                //return finTypeName
            },
            onClickLeft() {
                history.back();
            },
            getParams(){
                debugger
                this.pageInfo.month = this.$route.params.month;
                this.pageInfo.day = this.$route.params.day;
                this.pageInfo.finType = this.$route.params.finType;
                this.pageInfo.sortDetail = this.$route.params.sortDetail;
                this.pageInfo.statisticsFlag = this.$route.params.statisticsFlag;
            },
            onRefresh() {
                debugger
                // 清空列表数据
                this.finished = false;
                this.refreshing = true;

                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
          alterFin(finId){
                let month = this.pageInfo.month
                this.$router.push({ name:'finance',params:{finId:finId,month:month} })
            },
            alterTransFin(finId){
                let month = this.pageInfo.month
                this.$router.push({ name:'tranceFinance',params:{finId:finId,month:month} })
            },
            removeFin(finId){
                this.$dialog.confirm({
                    title: '删除',
                    message: '确认删除该数据吗？'
                }).then(() => {
                    let params = {"finId":finId}
                    this.$axios.post(MyApi.FINANCE_DEL_URL,params/*,options*/)
                        .then((response) =>  {
                            debugger
                            let code = response.code;
                            if(code == '200'){
                                this.$toast.success(response.msg);
                                // 清空列表数据
                                this.finished = false;
                                this.refreshing = true;
                                // 重新加载数据
                                // 将 loading 设置为 true，表示处于加载状态
                                this.loading = true;
                                this.onLoad();
                            }
                        })
                        .catch((err) =>{
                            this.$toast.fail("删除异常"+err);
                        })

                }).catch(() => {

                });
            },
            onClickLeft() {
                history.back();
            },
            showPopup() {
                this.popupShow = true;
            },
            getQryData(qryData) {

                this.popupShow = qryData.popupShow;
                this.pageInfo.belongs = qryData.belongs;
                this.pageInfo.startDate = qryData.startDate;
                this.pageInfo.endDate = qryData.endDate;
                this.pageInfo.sorts = qryData.sorts;
                this.pageInfo.payers = qryData.payers;
                this.pageInfo.finTypes = qryData.finTypes;
                this.pageInfo.details = qryData.details;
                this.pageInfo.tagIds = qryData.tags;
                this.onRefresh();

            },
            initTags(){

                let params = {};
                this.$axios.post(MyApi.FIN_QRY_TAGS,params/*,options*/)
                    .then((response) =>  {
                        debugger
                        let code = response.code;
                        if(code == '200'){
                            this.tags = response.data.tags
                        }
                    })
                    .catch((err) =>{
                        this.$toast.fail("处理异常"+err);
                    })
            },
            async selectTag(finId,tagId,event){
                const toast = this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '修改中,请稍后',
                });
                debugger;
                //如果没有default,说明是已经选中的标签
                if(event.target.className.indexOf('van-tag--default') == -1){
                    //取消选中
                    let flag = await this.modFinTag(tagId,finId,"DEL")
                    if(flag){
                        event.target.classList.replace('van-tag--primary','van-tag--default')
                    }
                }else{
                    //选中
                    let flag = await this.modFinTag(tagId,finId,"ADD")
                    if(flag){
                        event.target.classList.replace('van-tag--default','van-tag--primary')
                    }
                }
                toast.clear()

            },
            async modFinTag(tagId,finId,type){
                let params = {
                    "tagId": tagId,
                    "finId": finId,
                    "type": type
                }
                let res = false;

                await this.$axios.post(MyApi.FINANCE_MOD_TAG,params/*,options*/)
                    .then((response) =>  {
                        debugger
                        let code = response.code;
                        if(code == '200'){
                            res =  true;
                        }
                    })
                    .catch((err) =>{
                    })
                return res;

            },
            /**
             *
             * @param tags
             * @param tagId
             * @param isSelect 本来有标签的为true,渲染其他标签为false
             */
            isShow(tags,tagId,isSelect){
                debugger;
                if(isSelect){
                    if(tags.length == 0){
                        return false;
                    }
                }else{
                    if(tags.length > 0){
                        for(let i = 0 ; i < tags.length ; i++){
                            let tag = tags[i]
                            if(tag.tagId == tagId){
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            orderChange(){
                this.onRefresh();
            }

        }

    }


</script>

<style scoped="scoped">
    .upd-button {
        height: 100%;
    }
    .van-list >>> .van-list__finished-text{
        margin-bottom: 50px;
    }


</style>
